<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Consultar vehiculos</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <form class="row" [formGroup]="formConsultaVehiculo">
    <div class="col-md-6">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Categoría</mat-label>
        <mat-select formControlName="categoria">
          @for (categoria of catCategoria; track categoria) {
            <mat-option [value]="categoria.valor_dato">{{
            categoria.descripl_dato }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-6">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Modelo</mat-label>
        <mat-select formControlName="modelo">
          @for (modelo of catModelo; track modelo) {
            <mat-option [value]="modelo.modelo">{{ modelo.modelo
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-12">
      <mat-form-field class="inputFormularioSmall">
        <mat-label>Descripcion</mat-label>
        <input matInput type="text" formControlName="descripcion">
      </mat-form-field>
    </div>
  </form>

  <div class="row">
    <div class="col-md-12 my-4 overflow-auto">
      <table mat-table multiTemplateDataRows [dataSource]="datosVehiculos"
        class="table d-xl-table d-md-table table-responsive my-2">
        <ng-container matColumnDef="Marca">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Marca</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.des_marca}}</td>
        </ng-container>
        <ng-container matColumnDef="Subtipo">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Subtipo</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.descripcion}}</td>
        </ng-container>
        <ng-container matColumnDef="Descripcion">
          <th mat-header-cell class="px-2" *matHeaderCellDef>Descripcion</th>
          <td mat-cell *matCellDef="let element" class="mx-1">{{element?.des_vehiculo}}</td>
        </ng-container>

        <!-- Sin resultados -->
        <ng-container matColumnDef="noData">
          <td mat-footer-cell *matFooterCellDef colspan="3">
            <small>No se encontró ningún resultado</small>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns;  sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="seleccionarVehiculo(row)"> </tr>
        <tr mat-footer-row *matFooterRowDef="['noData']"
        [ngClass]="(datosVehiculos?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20, 50,100]" showFirstLastButtons
        aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
  </div>
</mat-dialog-content>